export const SERVICE_PROVIDER_EMAIL_ALREADY_EXISTS =
  'Service provider email already exists';

export const SERVICE_PROVIDER_NAME_ALREADY_EXISTS =
  'Service provider name already exists';
